const StepLoader = () => {
  return <div className="step-loader"></div>
}

export default StepLoader
